// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-popup-project-documents-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.5rem 0;
}

.dialog-popup-project-documents-label {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.dialog-popup-project-documents-title {
  font-size: var(--ui-font-md);
  font-weight: 600;
  color: #374151;
}

.dialog-popup-project-documents-description {
  font-size: var(--ui-font-sm);
  color: #6b7280;
  line-height: 1.4;
}

.dialog-popup-project-documents-link {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 0.3rem;
  color: var(--primary-color);
  font-size: var(--ui-font-sm-plus);
  font-weight: 600;
  line-height: 1;
  width: fit-content;
  text-decoration-line: underline;
  text-decoration-style: dotted;
  text-decoration-color: currentColor;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.16rem;
  -webkit-text-decoration-skip: ink;
          text-decoration-skip-ink: auto;
  transition: none;
}

.dialog-popup-project-documents-link:hover {
  color: #005886;
}

.dialog-popup-project-documents-link-disabled {
  color: #9ca3af;
  cursor: not-allowed;
  pointer-events: auto;
}

.dialog-popup-project-documents-link-disabled:hover {
  color: #9ca3af;
}

.dialog-popup-project-documents-link:focus-visible {
  outline: 3px solid rgba(0, 105, 165, 0.22);
  outline-offset: 2px;
}

.dialog-popup-project-documents-link-icon {
  display: block;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  stroke-width: 2.25;
}
`, "",{"version":3,"sources":["webpack://./src/components/DialogPopup/DialogPopupProjectDocuments/DialogPopupProjectDocuments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,mCAAmC;EACnC,8BAA8B;EAC9B,8BAA8B;EAC9B,iCAA8B;UAA9B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".dialog-popup-project-documents-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n}\n\n.dialog-popup-project-documents-label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.dialog-popup-project-documents-title {\n  font-size: var(--ui-font-md);\n  font-weight: 600;\n  color: #374151;\n}\n\n.dialog-popup-project-documents-description {\n  font-size: var(--ui-font-sm);\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.dialog-popup-project-documents-link {\n  display: inline-flex;\n  align-self: flex-start;\n  align-items: center;\n  gap: 0.3rem;\n  color: var(--primary-color);\n  font-size: var(--ui-font-sm-plus);\n  font-weight: 600;\n  line-height: 1;\n  width: fit-content;\n  text-decoration-line: underline;\n  text-decoration-style: dotted;\n  text-decoration-color: currentColor;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.16rem;\n  text-decoration-skip-ink: auto;\n  transition: none;\n}\n\n.dialog-popup-project-documents-link:hover {\n  color: #005886;\n}\n\n.dialog-popup-project-documents-link-disabled {\n  color: #9ca3af;\n  cursor: not-allowed;\n  pointer-events: auto;\n}\n\n.dialog-popup-project-documents-link-disabled:hover {\n  color: #9ca3af;\n}\n\n.dialog-popup-project-documents-link:focus-visible {\n  outline: 3px solid rgba(0, 105, 165, 0.22);\n  outline-offset: 2px;\n}\n\n.dialog-popup-project-documents-link-icon {\n  display: block;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  stroke-width: 2.25;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
